import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect,MultiSelect } from 'vue-search-select'
import Pagination from './../../../../shared/components/pagination'
import CustomExpandableTable from './../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import Util from './../../../../shared/util/util'
import CONSTANT from './../../../../shared/constants/constant'
import ClientService from './../../../services/clientmanagement.service';
import Multiselect from 'vue-multiselect'
export default {
  name: 'ClientUploadLocations',
  components: {
    VueElementLoading,
    Pagination,
    BasicSelect,
    CustomExpandableTable,
    Loader,
    ClientService,
    Multiselect
  },

  props: ['selectedContractServiceObj'],

  data: function() {
    return {
      isLoading: false,
      companyNamelist: [],
      selectedcompanyName: {
        value: '',
        text: '',
        CompanyName: '',
      },
      companyName: '',
      locationtype: '',
      fileerror: '',
      fileList:'',
      clienterr: '',
      userName: '',
      uploadtypeerr:'',
      clientbusinessaccountid:''
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.getCompanyShortName();

  },
  methods: {
    async getCompanyShortName() {
      try {
        let inputPayload = {};
        var CompanyShortList = [];
        let result = await ClientService.GetCargoClientList(inputPayload)
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          if(CompanyShortList[i].ClientShortName){
            this.companyNamelist.push({
              'value': CompanyShortList[i].ClientMasterID,
              'text': CompanyShortList[i].ClientShortName,
              'CompanyName': CompanyShortList[i].AccountName,
              'ClientBusinessAccountId' : CompanyShortList[i].ClientBusinessAccountId,
            })
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    handleFileUpload(fileList) {
      this.file = this.$refs.file.files[0];
      this.fileList = fileList
    },

    async UploadProduct() {
      try{
        if (this.isCheck()) {
          return false
        }
        this.fileerror = ''
        let formData = new FormData();
        formData.append('file', this.file);
        formData.append('companyName', this.companyName.text);
        formData.append('createdby', this.userName);
        formData.append('locationtype', this.locationtype);
        formData.append('clientid', this.clientid);
        formData.append('clientbusinessaccountid', this.clientbusinessaccountid);

        this.isLoading = true;
        let result = await ClientService.uploadClientLocation(formData)
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$fire({
            title: "Success",
            text: "Location Uploaded Successfully",
            type: "success",
           timer: 2000
          })
          this.clearFields
        } else {
          this.$fire({
            title: "Error",
            text: result.data.data[0].msg,
            type: "error",
            timer: 2000
          })
        }
      } catch (err) {
        this.isLoading = false;
        console.log(err);
        this.$fire({
          title: "Error",
          text: "Internal Server Error",
          type: "error",
          timer: 2000
        })
      }
    },

    isCheck(){
      let err = 0
      if(!this.companyName){
        err = 1
        this.clienterr = "Select Client"
      }else{
        this.clienterr = ""
      }
      if(!this.file){
        err = 1
        this.fileerror = 'Please Select File'
      }else{
        this.fileerror = ''
      }
      if(!this.locationtype){
        err = 1
        this.uploadtypeerr = 'Please Select Upload Type'
      }else{
        this.uploadtypeerr = ''
      }
      return err
    },

    clearFields(){
      this.companyName = ''
      this.clientid = ''
      this.selectedcompanyName = {}
      this.locationtype = ''
      this.file = ''
    },

    selectCompanyName(data) {
      this.selectedcompanyName = data;
      this.companyName = data.text;
      this.clientid = data.value;
      this.clientbusinessaccountid = data.ClientBusinessAccountId;
    },

    showUploadLocationList(){
      this.$emit("goBackToParent")
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/ClientLocations/UploadLocations/UploadLocations.component.js